// Utility function to scroll to top of page
export const scrollToTop = () => {
  // Multiple methods to ensure scroll works
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: 'smooth'
  });
  
  // Fallback for older browsers
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
  
  // Additional fallback
  setTimeout(() => {
    window.scrollTo(0, 0);
  }, 100);
};

// Utility function for immediate scroll to top (no animation)
export const scrollToTopImmediate = () => {
  window.scrollTo(0, 0);
};

